var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerifyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 101,
    viewBox: "0 0 100 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.3467 8C47.2471 5.97025 52.7529 5.97025 57.6533 8L74.6406 15.0361C79.5408 17.066 83.434 20.9592 85.4639 25.8594L92.5 42.8467C94.5297 47.7471 94.5298 53.2529 92.5 58.1533L85.4639 75.1406C83.434 80.0408 79.5408 83.934 74.6406 85.9639L57.6533 93C52.7529 95.0297 47.2471 95.0298 42.3467 93L25.3594 85.9639C20.4592 83.934 16.566 80.0408 14.5361 75.1406L7.5 58.1533C5.47025 53.2529 5.47025 47.7471 7.5 42.8467L14.5361 25.8594C16.566 20.9592 20.4592 17.066 25.3594 15.0361L42.3467 8Z",
    fill: "#FFAE58",
    stroke: "#9983FC",
    strokeWidth: 8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.8826 38.3801C62.4424 37.8252 63.1981 37.5129 63.9863 37.5108C64.7745 37.5086 65.532 37.8167 66.0948 38.3685C66.6577 38.9203 66.9807 39.6715 66.9942 40.4596C67.0076 41.2477 66.7103 42.0095 66.1666 42.5801L50.1986 62.5401C49.9241 62.8357 49.5929 63.073 49.2247 63.2376C48.8565 63.4023 48.4589 63.491 48.0556 63.4985C47.6523 63.5059 47.2517 63.432 46.8776 63.2811C46.5036 63.1302 46.1638 62.9054 45.8786 62.6201L35.2986 52.0361C35.0038 51.7615 34.7674 51.4303 34.6035 51.0623C34.4395 50.6943 34.3513 50.297 34.3442 49.8942C34.3371 49.4914 34.4112 49.0913 34.5621 48.7178C34.713 48.3442 34.9376 48.0049 35.2224 47.72C35.5073 47.4351 35.8466 47.2105 36.2202 47.0597C36.5937 46.9088 36.9939 46.8347 37.3967 46.8418C37.7995 46.8489 38.1967 46.9371 38.5647 47.101C38.9327 47.265 39.2639 47.5014 39.5386 47.7961L47.9146 56.1681L61.8066 38.4681C61.8314 38.4372 61.8581 38.4078 61.8866 38.3801H61.8826Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerifyIcon);
export default __webpack_public_path__ + "static/media/verify-icon.780ba588affae432cb0033408330cd54.svg";
export { ForwardRef as ReactComponent };